import { applyUserTranslationsAllTypes } from "@/lib/utils";
import type {
  ProyectosPropios,
  ActuacionesPropias,
  TransaccionesPropias,
} from "@/types/models/propios";
import { propiosRepository } from "../repositories/propios.repository";
import { mapProyectosPropiosWithRelations } from "../mappers/propios.mappers";

export const propiosService = {
  async fetchProyectosPropiosByTenant(params: {
    tenantId: number;
    userLang: string;
  }): Promise<ProyectosPropios[]> {
    const [proyectosData, actuacionesData, transaccionesData] =
      await Promise.all([
        propiosRepository.fetchProyectosPropiosByTenant(params.tenantId),
        propiosRepository.fetchActuacionesPropiasByTenant(params.tenantId),
        propiosRepository.fetchTransaccionesPropiasByTenant(params.tenantId),
      ]);

    const proyectos = applyUserTranslationsAllTypes(
      proyectosData ?? [],
      params.userLang,
      ["nombre", "observaciones"]
    );

    const actuaciones = applyUserTranslationsAllTypes(
      actuacionesData ?? [],
      params.userLang,
      ["nombre", "descripcion"]
    );

    return mapProyectosPropiosWithRelations({
      proyectos,
      actuaciones,
      transacciones: transaccionesData ?? [],
    });
  },

  async fetchActuacionesPropiasByTenant(params: {
    tenantId: number;
    userLang: string;
  }): Promise<ActuacionesPropias[]> {
    const data = await propiosRepository.fetchActuacionesPropiasByTenant(
      params.tenantId
    );

    return applyUserTranslationsAllTypes(
      data ?? [],
      params.userLang,
      ["nombre", "descripcion"]
    );
  },

  async fetchTransaccionesPropiasByTenant(params: {
    tenantId: number;
  }): Promise<TransaccionesPropias[]> {
    return (
      (await propiosRepository.fetchTransaccionesPropiasByTenant(
        params.tenantId
      )) ?? []
    );
  },

  createProyectoPropio: propiosRepository.createProyectoPropio,
  updateProyectoPropio: propiosRepository.updateProyectoPropio,
  deleteProyectoPropio: propiosRepository.deleteProyectoPropio,

  createActuacionPropia: propiosRepository.createActuacionPropia,
  updateActuacionPropia: propiosRepository.updateActuacionPropia,
  deleteActuacionPropia: propiosRepository.deleteActuacionPropia,

  createTransaccionPropia: propiosRepository.createTransaccionPropia,
  updateTransaccionPropia: propiosRepository.updateTransaccionPropia,
  deleteTransaccionPropia: propiosRepository.deleteTransaccionPropia,
};